import { FoodOption } from './food-option';
import { Macros } from './macros';

export interface Diet {
  id: number;
  name: string;
  finishedAt: string;
  description: string;
  createdAt: string;
  finishAt: { Time: string; Valid: boolean };
  startedAt: string;
  startAt: string;
  userId: number;
  totalWeeks?: number;
  allowCheatMeals?: number;
  periodCheatMeals?: number;
  meals: Meal[];
  trainerUserLastName: string;
  status?: string;
  trainerUserName: string;
  macros?: Macros;
  water?: number;
  daysOfWeek?: string[];
  activeDiets?: any;

  // internal use
  finished?: boolean; // This property is added in the client for easier managment of states
  parsedFinishAt?: string;
  loading?: boolean;
  parsedStartAt?: string;
}

export interface Meal {
  id: number;
  order: number;
  title: string;
  description: string;
  dietId: number;
  foodOptions: FoodOption[][];
  macros?: Macros;

  // internal use
  selected?: boolean;
  imported?: boolean;
}
